import { useState, useCallback } from 'react'

export default function useIsFocused() {
  const [isFocused, setFocused] = useState(false)
  const onFocus = useCallback(() => setFocused(true), [])
  const onBlur = useCallback(() => setFocused(false), [])

  return [isFocused, { onFocus, onBlur }] as const
}
